

























































































import Vue from "vue";

import AudioElement from "@tt-app/components/exercise/common/AudioElement.vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";
import PictureMatchOption from "@tt-app/components/exercise/PictureMatchOption.vue";
import Separator from "@tt-app/components/ui/Separator.vue";
import { concatenatedStringArray } from "@tt-app/utils"

import IconChevronDown from "@joyz/app-core/assets/icons/transparent/ChevronDown.svg";
import IconSelected from "@joyz/app-core/assets/icons/misc/TT4WRadioChecked.svg";
import IconUnselected from "@joyz/app-core/assets/icons/misc/TT4WRadio.svg";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Answer {
  isCorrect: boolean;
  correctId: number;
  selectedId: number;
}

interface PictureMatchOption {
  header: string[];
  id: number;
  image: string;
}

interface Data {
  dropdownOpen: boolean;
  icons: {
    [key: string]: string;
  };
}

interface Methods {
  correct(option: PictureMatchOption): undefined | boolean;
  incorrect(option: PictureMatchOption): undefined | boolean;
  selectOption(option: PictureMatchOption): void;
  status(option: PictureMatchOption): undefined | string;
  toggleCollapse(): void;
  concatenatedBody: (body: string | string[]) => string;
}

interface Computed {
  hasCorrectOption: boolean;
  problemUuid: undefined | string;
}

interface Props {
  answer: any;
  audioDecoderPlayer: AudioDecoderPlayer;
  body: {
    problemUuid: string;
    type: string;
  }[];
  header: any;
  review: any;
  selectedOptionIndex: number;
  totalQuestions: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PictureMatchMultipleChoice",

  components: {
    AudioElement,
    PictureMatchOption,
    ExerciseHtmlText,
    Separator
  },

  props: {
    answer: {
      type: Object,
      default: undefined
    },

    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },

    header: {
      type: Array,
      required: true
    },

    body: {
      type: Array,
      required: true
    },

    review: {
      type: Object,
      default: undefined
    },

    selectedOptionIndex: {
      type: Number,
      default: undefined
    },

    totalQuestions: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dropdownOpen: false,
      icons: {
        chevronDown: IconChevronDown,
        unselected: IconUnselected,
        selected: IconSelected
      }
    };
  },
  computed: {
    hasCorrectOption() {
      return !!this.answer;
    },

    problemUuid() {
      if (!this.body) {
        return;
      }

      const problemComponent = this.body.find(component => {
        return component.type === "IMAGE_SINGLE_SELECTION";
      });

      return problemComponent?.problemUuid;
    }
  },

  methods: {
    correct(option) {
      if (!this.answer) {
        return undefined;
      }

      return this.answer.correctId === option.id;
    },

    incorrect(option) {
      if (!this.answer) {
        return undefined;
      }

      return !this.correct(option) && this.answer.selectedId === option.id;
    },

    selectOption(selectedOption) {
      this.$emit("select-option-index", { problemUuid: this.problemUuid, id: selectedOption.id });
    },

    status(option) {
      if (this.hasCorrectOption) {
        return undefined;
      }

      return option.id === this.selectedOptionIndex ? "selected" : "unselected";
    },

    toggleCollapse() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    concatenatedBody(elementBody) {
      return concatenatedStringArray(elementBody);
    }
  }
});
